import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { RolloverRequest } from '../../models/rollover-request.model';
import { environment } from '../../../../environments/environment';
import { ApprovedRollover } from '../../../features/credit-and-risk/rollover-management/models/approved-rollover';
import { RolloverDetailView } from '../../../features/credit-and-risk/rollover-management/models/rollover-detail-view';
import { PaginatedResponse } from '../../models/paginated-response';
@Injectable({
  providedIn: 'root'
})
export class RolloverService {
  private readonly apiUrl = `${environment.apiGatewayBaseUrl}/RollOvers`;

  constructor(private http: HttpClient) { }

  getRolloverRequests(): Observable<ApiResponse<RolloverRequest[]>> {
    return this.http.get<ApiResponse<RolloverRequest[]>>(`${this.apiUrl}/requests`);
  }

  authorizeRollOverRequest(requestId: any, approvalUpdate: any): Observable<ApiResponse<boolean>> {
    return this.http.patch<ApiResponse<boolean>>(`${this.apiUrl}/requests/${requestId}`, approvalUpdate);
  }

  getApprovedRolloverRequests(): Observable<ApiResponse<Array<ApprovedRollover>>> {
    return this.http.get<ApiResponse<Array<ApprovedRollover>>>(`${this.apiUrl}/approved-rollovers`);
  }

  getDetailsViewOfRolloverRequest(companyRollOverId: number): Observable<ApiResponse<RolloverDetailView>> {
    return this.http.get<ApiResponse<RolloverDetailView>>(`${this.apiUrl}/rollover-details/${companyRollOverId}`);
  }

  // ====================== paginated ======================== //
  getApprovedRolloversPaginated(
    pageNumber: number, pageSize: number,
    companyId?: string | null, isPaid?: boolean | null,
    startDate?: string | null, endDate?: string | null
  ): Observable<PaginatedResponse<ApprovedRollover>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);
    if (companyId != null) params = params.set('companyId', companyId);
    if (isPaid != null) params = params.set('isPaid', isPaid);
    if (startDate) params = params.set('startDate', startDate);
    if (endDate) params = params.set('endDate', endDate);
    return this.http.get<PaginatedResponse<ApprovedRollover>>(`${this.apiUrl}/approved-rollovers/paginated`, { params });
  }

  getRolloverRequestsPaginated(
    pageNumber: number, pageSize: number,
    companyId?: string | null, isPaid?: boolean | null,
    isActive?: boolean | null, startDate?: string | null, endDate?: string | null
  ): Observable<PaginatedResponse<RolloverRequest>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);
    if (companyId != null) params = params.set('companyId', companyId);
    if (isPaid != null) params = params.set('isPaid', isPaid);
    if (isActive != null) params = params.set('isActive', isActive);
    if (startDate) params = params.set('startDate', startDate);
    if (endDate) params = params.set('endDate', endDate);
    return this.http.get<PaginatedResponse<RolloverRequest>>(`${this.apiUrl}/requests/paginated`, { params });
  }
}
  